module.exports = __webpack_public_path__ + "img/C04TechSparabara2_ua.1a6a76f0.webp";